import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";

import { ButtonComponent, LinkModule } from "@bitwarden/components";

@Component({
  selector: "app-privacy-policy",
  templateUrl: "./privacy-policy.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, LinkModule, RouterLink],
})
export class PrivacyPolicyComponent {
  protected readonly year = new Date().getFullYear();

  protected readonly tocSections = [
    { id: "legal-section-1", label: "Information we collect" },
    { id: "legal-section-2", label: "Website & app data" },
    { id: "legal-section-3", label: "Analytics" },
    { id: "legal-section-4", label: "How we use data" },
    { id: "legal-section-5", label: "Data retention" },
    { id: "legal-section-6", label: "Access & deletion" },
    { id: "legal-section-7", label: "Information sharing" },
    { id: "legal-section-8", label: "International transfers" },
    { id: "legal-section-9", label: "Security" },
    { id: "legal-section-10", label: "Cookies" },
    { id: "legal-section-11", label: "Third-party links" },
    { id: "legal-section-12", label: "Children's privacy" },
    { id: "legal-section-13", label: "Policy updates" },
    { id: "legal-section-14", label: "Contact us" },
  ] as const;

  scrollToSection(sectionId: string): void {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
